import { useApi } from "~/providers/ApiProvider";
import { useImperativeModal } from "ImperativeModalProvider";
import { useUI } from "~/hooks/useUI";
import { ConfirmModal } from "components/Modal/ConfirmModal";

export const useNaverConflict = () => {
  const { appointmentApi } = useApi();
  const imperativeModal = useImperativeModal();
  const ui = useUI();

  const handleNaverConflict = async (
    id: string,
    params: any,
    onSuccess: (response: any) => Promise<void> | void,
    onError: (e: any) => void
  ) => {
    const confirmed = await imperativeModal.open((close) => (
      <ConfirmModal
        body={
          <>
            네이버 예약과 시간 단위가 다릅니다.
            <br />
            네이버 예약 취소 및 연동 해제 후 변경하시겠습니까?
          </>
        }
        onConfirm={() => close(true)}
        onClose={() => close(false)}
        open={true}
      />
    ));
    if (!confirmed) {
      return;
    }
    try {
      ui.setLoading(true);
      const resp = await appointmentApi.editAppointment(id, {
        ...params,
        externalCancelAndUnlink: true,
      });
      await onSuccess(resp.data);
    } catch (e: any) {
      onError(e);
    } finally {
      ui.setLoading(false);
    }
  };

  return { handleNaverConflict };
};
